export default __webpack_public_path__ + "static/media/CEO.b97487dd.png";